import CountdownTimer from "@components/CountdownTimer"
import SubscriptionForm from "@components/SubscriptionForm"
import { useTranslation } from "react-i18next"
import { StripePrice } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  fullPrice: StripePrice | undefined
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  endTime: number
  isMonthly: boolean
}

export default function LimitedTimeOfferBanner({
  currency,
  isSubmitting,
  fullPrice,
  priceId,
  setIsSubmitting,
  endTime,
  isMonthly,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="bg-custom-teal-light space-y-3">
      <div className="custom-container flex grow flex-row items-center justify-between py-4">
        <div className="flex flex-col">
          <p className="text-custom-charcoal font-bold">
            {t("pages.checkout.plans.discount_reserved")}
          </p>

          <CountdownTimer
            endTime={endTime}
            className="text-custom-teal-dark text-3xl font-bold"
          />
        </div>

        <SubscriptionForm
          buttonClassName="px-3! py-2! font-bold! text-base! shadow-none!"
          buttonTitle={t("pages.checkout.plans.startNow")}
          currency={currency}
          fullPrice={fullPrice}
          isSubmitting={isSubmitting}
          plan={isMonthly ? "monthly" : "yearly"}
          priceId={priceId}
          setIsSubmitting={setIsSubmitting}
        />
      </div>
    </div>
  )
}
